import InlineInfoBlock from './InlineInfoBlock';

export default InlineInfoBlock;
